import { ActionButton, DataGridPage } from '@if/mui'
import { useDevTools } from '@src/types/constants'
import { Plus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { loanDashBoardFiltersSchema } from './loan-filters-schema'
import { useLoanDashboardEntries, useLoanListColumns } from './LoanList-hooks'

const DEFAULT_LIMIT = 50

const LoanList = () => {
  const { t } = useTranslation()
  const columns = useLoanListColumns()

  return (
    <DataGridPage
      schema={loanDashBoardFiltersSchema}
      searchField="searchTerm"
      useData={useLoanDashboardEntries}
      columns={columns}
      dataSourceIdKey="loanId"
      defaultLimit={DEFAULT_LIMIT}
      canChangePageSize
      searchPlaceholder={t('loan.loanList.searchPlaceholder')}
      actions={
        useDevTools ? (
          <ActionButton emphasis="principal" startIcon={Plus} href="/loans/create">
            {t('menus.loans.create')}
          </ActionButton>
        ) : undefined
      }
    />
  )
}

export default LoanList
